import { useCallback, useState } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useQueryParamValue } from '#src/app/shared/hooks/location';

import { useGetEmbedUrl } from './useGetEmbedUrl';

type Result = ModelHookResult<
	{ embedHtml: string; shouldShowVideoOnLoad: boolean; modalIsOpen: boolean },
	{ handleButtonClick: () => void; showVideo: () => void; handleCloseModal: (isOpen: boolean) => void }
>;

export function useHeroVideoButton(): Result {
	const track = useTracking();
	const ov = useQueryParamValue('ov');
	const shouldShowVideoOnLoad = ov === 'true';
	const [modalIsOpen, setModalIsOpen] = useState<boolean>(shouldShowVideoOnLoad);
	const {
		data: { embedHtml },
	} = useGetEmbedUrl();

	const handleButtonClick = useCallback(() => {
		if (ov !== 'true') {
			void track('about_impact_video_manual_click');
		}
		setModalIsOpen(true);
	}, [track, ov]);

	const showVideo = useCallback(() => {
		setModalIsOpen(true);
	}, []);

	const handleCloseModal = useCallback((isOpen: boolean) => {
		setModalIsOpen(isOpen);
	}, []);

	return {
		data: { embedHtml, modalIsOpen, shouldShowVideoOnLoad },
		actions: { handleButtonClick, handleCloseModal, showVideo },
	};
}
